import React from "react";
import homeImg from "./../images/homeImg.png";
import { advantageCartData } from "../data/advantageCartData";
import { AdvantageCart } from "../components/AdvantageCart";
import { ButtonBg } from "../components/ButtonBg";
import { Link } from "react-router-dom";
import { Search } from "../components/Search";

export const Home = () => {
  return (
    <div className="flex flex-col p-5 md:p-10">
      <div className="px-5 md:hidden">
        <Search />
      </div>
      <div className="flex flex-col-reverse my-3 lg:flex-row">
        <div className="w-full lg:w-1/2 p-5">
          <h1 className="text-3xl font-bold mb-5 md:text-5xl sm:text-4xl">
            Unlock your potential, instantly!
          </h1>
          <p className="text-xl mb-5">
            Enjoy unparalleld access to life-changing insights from the world's
            top self-help books. Imagine tapping into the collective wisdom of
            leading experts in personal and professinal development, all
            tailored to your unique needs and goals.
          </p>
          <Link to="/books">
            <ButtonBg text="Browse Books for free" />
          </Link>
        </div>
        <div className="w-full lg:w-1/2 p-5">
          <img
            src={homeImg}
            alt="homeImg"
            className="rounded-2xl mb-5 mx-auto"
          />
        </div>
      </div>

      <div className="my-6 lg:flex">
        {advantageCartData?.map((item) => (
          <AdvantageCart item={item} key={item.id} />
        ))}
      </div>
    </div>
  );
};
